module.exports = __webpack_public_path__ + "static/img/dev_banner.732ee15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developerCommunity/dev_banner.jpg
// module id = nt3E
// module chunks = 19